const apiBaseUrl = (process.env.API_BASE_URL || '').replace(/\/$/, '')
const imageBaseUrl = (process.env.VUE_APP_IMGURL || 'https://drs-1304378824.cos.ap-guangzhou.myqcloud.com/').replace(/\/$/, '')
const fileServicePrefix = '/drs-serv'
const resourcePrefix = '/profile'

function withApiBase(path) {
  return apiBaseUrl ? `${apiBaseUrl}${path}` : path
}

function withImageBase(path) {
  return imageBaseUrl ? `${imageBaseUrl}/${path.replace(/^\/+/, '')}` : withApiBase(`${fileServicePrefix}${resourcePrefix}${path}`)
}

export function buildFileUrl(objKey) {
  const value = String(objKey || '').trim()
  if (!value) return ''
  if (/^(data:|blob:|https?:\/\/)/.test(value)) return value
  const path = value.charAt(0) === '/' ? value : `/${value}`
  if (path.indexOf(`${fileServicePrefix}/`) === 0) {
    return withApiBase(path)
  }
  if (path.indexOf(`${resourcePrefix}/`) === 0) {
    return withApiBase(`${fileServicePrefix}${path}`)
  }
  return withImageBase(path)
}



// WEBPACK FOOTER //
// ./src/utils/fileUrl.js